<template>
  <div>
    <hi-row v-if="multiple" separator :py="15">
      <span
        @click="select('all')"
        class="item nowrap"
        :class="{ selected: isAllSelected }"
        >Select All</span
      >
    </hi-row>
    <hi-row flex :py="15">
      <span
        @click="select(item)"
        class="item nowrap"
        :class="{ selected: isSelected(item) }"
        v-for="item in displayItems"
        :key="item.value"
        >{{ item.text }}</span
      >
    </hi-row>
  </div>
</template>

<script>
import HiRow from "@/components/scaffold/HiRow";
export default {
  name: "HiFlatSelection",
  components: { HiRow },
  props: {
    items: {
      type: Array,
      required: true
    },
    itemValue: {
      //the value key for the item
      type: String,
      default: "value"
    },
    itemText: {
      //value to be displayed
      type: String,
      default: "text"
    },
    itemTextAdditional: {
      // additional value to be displayed in ()
      type: String
    },
    multiple: {
      // show selectAll btn
      type: Boolean
    },
    selectedItems: {
      type: [Array, String]
    }
  },
  data() {
    return {
      isAllSelected: false,
      selected: []
    };
  },
  methods: {
    resetData() {
      this.displayData.splice(0);
      this.items.forEach((v, index) => {
        this.$set(this.displayData, index, {
          label: this.displayItem(v),
          val: this.itemValue ? v[this.itemValue] : v
        });
      });
    },
    select(item) {
      // console.log(index);
      if (item === "all") {
        this.isAllSelected = !this.isAllSelected;
        if (this.isAllSelected) {
          this.unselectAll();
        }
        return;
      }
      const val = item.value;
      let wasSelected = false;
      for (let i = this.selected.length - 1; i >= 0; i--) {
        if (this.selected[i] === val) {
          this.selected.splice(i, 1);
          wasSelected = true;
          break;
        }
      }
      if (!wasSelected) {
        this.selected.push(val);
      }
      this.isAllSelected = false;
      // const o = this.displayData[index];
      // o.selected = !o.selected;
      // this.$set(this.displayData, index, o);
      // this.isAllSelected = false;
      // const val = item[this.itemValue];
      // this.value.push(val);
    },
    // displayItem(item) {
    //   let display = this.itemText ? item[this.itemText] : item.toString();
    //   if (this.itemTextAdditional)
    //     display += " (" + item[this.itemTextAdditional] + ")";
    //   return display;
    // },
    isSelected(item) {
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i] === item.value) return true;
      }
      return false;
    },
    unselectAll() {
      this.selected.splice(0, this.selected.length);
    },
    setValue(val) {
      if (val === "all") {
        this.unselectAll();
        this.isAllSelected = true;
      } else {
        this.selected = val;
      }
    },
    getValue() {
      if (this.isAllSelected) {
        return "all";
      } else {
        return this.selected.slice();
      }
    }
  },
  computed: {
    displayItems() {
      const items = [];
      // console.log(this.items);
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const obj = { value: item[this.itemValue] };
        let text = item[this.itemText];
        if (this.itemTextAdditional) {
          const add = item[this.itemTextAdditional];
          if (add) text += "(" + add + ")";
        }
        obj.text = text;
        items.push(obj);
      }
      // console.log(items);
      return items;
    }
  },
  mounted() {
    if (this.selectedItems) {
      console.log("mounted");
      console.log(this.selectedItems);
      this.setValue(this.selectedItems);
    }
  }
};
</script>

<style lang="scss">
@import "~@/styles/variables.scss";
.item {
  transition: all 0.5s;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 4px;
  border-radius: 4px;
  letter-spacing: 0.1em;
  margin: 6px;
  cursor: pointer;
}
.item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.item.selected {
  background-color: $gold;
}
.item.selected:hover {
  background-color: $gold-hover;
}
</style>
